import styled from 'styled-components';

export const StyledBar = styled.div<{ isCongratulationModal?: boolean; isGradient?: boolean }>`
  position: relative;
  height: 6rem;
  width: 100%;
  display: flex;
  gap: 3.2rem;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.white};
  background: ${({ isGradient }) =>
    isGradient
      ? 'radial-gradient(ellipse 86.8rem 39.8rem at 10% -80%, rgba(162, 10, 42, 1) 0%, transparent 50%), radial-gradient(ellipse 86.8rem 39.8rem at 90% 300%, rgba(162, 10, 42, 1) 0%, transparent 50%), rgba(18, 18, 18, 1)'
      : 'rgba(18, 18, 18, 1);'};

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    display: block;
    height: auto;
    padding: 1.2rem;
    text-align: center;
  }

  p {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    letter-spacing: -0.03em;
    text-align: center;
    font-size: 2.2rem;
    margin: 0;
    @media (max-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: 1rem;
    }
  }

  p span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  a {
    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const StyledWrapper = styled.div<{ isTransparent?: boolean }>`
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
`;

export const StyledCTAButtonLinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.6rem;

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column-reverse;
    gap: 1.2rem;
  }
`;

export const StyledCopyAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semiBold};

  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;

export const StyledCloseBtn = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  color: ${({ theme }) => theme.colors.grey[500]};
  cursor: pointer;

  svg {
    height: 2rem;
    width: 2rem;
  }
`;
